import Cookies from 'js-cookie';

/**
 * @description The methods that we want to add x-csrf-token header to
 */
const xCsrfIgnoreMethods = [
  'get',
  'head',
  'options',
];

/**
 * @description The name of the cookie where we will find the x-csrf-token
 */
const xCsrfCookie = 'x-csrf-token';

/**
 * @description Determine whether or not we should add the x-csrf-token header to a request
 * @param {object} requestConfig - The axios request config [RequestConfig](https://axios-http.com/docs/req_config)
 * @returns {boolean} true/false
 */
const shouldAddXCsrfHeader = (requestConfig) => (
  !xCsrfIgnoreMethods.includes(requestConfig.method.toLowerCase())
  && !requestConfig.headers?.[xCsrfCookie]
);

/**
 * @description Handle changes to the requestConfig headers
 * @param {object} requestConfig - The axios request config [RequestConfig](https://axios-http.com/docs/req_config)
 * @returns {object} The updated requestConfig
 */
const addSecurityHeaders = (requestConfig) => {
  try {
    const newConfig = { ...requestConfig };
    const xCsrfToken = Cookies.get(xCsrfCookie);
    if (xCsrfToken && shouldAddXCsrfHeader(requestConfig)) {
      newConfig.headers[xCsrfCookie] = xCsrfToken;
    }
    return newConfig;
  } catch (error) {
    throw new Error(`Error in requestSecurityInterceptor: ${error.message}`, { cause: error });
  }
};

/**
 * @description An interceptor that adds x-csrf-token to each outgoing post/put request
 * @param {object} axios - The axios object that we are intercepting
 */
const requestSecurityInterceptor = (axios) => {
  axios.interceptors.request.use(
    (requestConfig) => addSecurityHeaders(requestConfig),
    (error) => Promise.reject(error),
  );
};

export {
  requestSecurityInterceptor,
  addSecurityHeaders,
  shouldAddXCsrfHeader,
  xCsrfCookie,
};
